import { render, staticRenderFns } from "./WordGroups.vue?vue&type=template&id=7182440c&"
import script from "./WordGroups.vue?vue&type=script&lang=js&"
export * from "./WordGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports